import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./Autopilot.css";
const formatTime = (value) => {
    const minutes = Math.floor(value / 60);
    const secs = value % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};
const Autopilot = ({ onStart, onStop, onClose }) => {
    const { t } = useTranslation();
    const [seconds, setSeconds] = useState("");
    const [remaining, setRemaining] = useState(null);
    const isValid = /^\d+$/.test(seconds) && Number(seconds) > 0;
    const isRunning = remaining !== null && remaining > 0;
    const isFinished = remaining !== null && remaining <= 0;
    useEffect(() => {
        if (remaining === null || remaining <= 0) {
            return;
        }
        const timer = setTimeout(() => setRemaining(remaining - 1), 1000);
        return () => clearTimeout(timer);
    }, [remaining]);
    const start = () => {
        if (isValid) {
            onStart(Number(seconds))
                .then(() => setRemaining(Number(seconds)))
                .catch(() => { });
        }
    };
    const stop = () => {
        onStop()
            .then(() => setRemaining(null))
            .catch(() => { });
    };
    return (_jsx("div", { className: "modal-wrapper", children: _jsxs("dialog", { open: true, onCancel: onClose, children: [_jsx("h4", { children: t("autopilot.modal.title") }), _jsxs("div", { className: "text-center", children: [!isRunning && !isFinished && (_jsxs("p", { className: "text-left autopilot-warning", children: ["\u26A0 ", t("autopilot.modal.warning")] })), _jsx("p", { className: "text-left", children: isFinished
                                ? t("autopilot.modal.waitConnection")
                                : t("autopilot.modal.description") }), !isRunning && !isFinished && (_jsxs(_Fragment, { children: [_jsx("div", { className: "input-wrapper", children: _jsx("input", { value: seconds, onChange: (e) => setSeconds(e.target.value.replace(/\D/g, "")), name: "seconds", type: "text", inputMode: "numeric", placeholder: t("autopilot.modal.seconds") }) }), _jsx("button", { className: "btn btn-primary", disabled: !isValid, onClick: start, children: t("autopilot.modal.startButton") }), _jsx("button", { className: "btn btn-secondary", onClick: onClose, children: t("autopilot.modal.closeButton") })] })), isRunning && (_jsxs(_Fragment, { children: [_jsx("div", { className: `autopilot-countdown ${remaining <= 3 ? "ending" : ""}`, children: formatTime(remaining) }), _jsx("button", { className: "btn autopilot-stop", onClick: stop, children: t("autopilot.modal.stopButton") })] })), isFinished && (_jsx("button", { className: "btn btn-secondary", onClick: onClose, children: t("autopilot.modal.closeButton") }))] })] }) }));
};
export default Autopilot;
